import { CapabilityIdEnum } from './capability-id.enum';
import { CapabilitySpecification } from './capability-specification.model';

const keyPrefix = 'admin/users/capabilities/';

const specificationAnswer = {
  id: CapabilityIdEnum.Answer,
  value: 'answer',
  label: `${keyPrefix}answer`,
};
const specificationActions = {
  id: CapabilityIdEnum.Actions,
  value: 'actions',
  label: `${keyPrefix}actions-facebook`,
};
const specificationStatistics = {
  id: CapabilityIdEnum.Statistics,
  value: 'statistics',
  label: `${keyPrefix}statistics`,
};
const specificationPublish = {
  id: CapabilityIdEnum.Publish,
  value: 'publish',
  label: `${keyPrefix}publish`,
};
const specificationProcessHelpRequests = {
  id: CapabilityIdEnum.ProcessHelpRequests,
  value: 'process_help_requests',
  label: `${keyPrefix}process-help-requests`,
};
const specificationRoute = {
  id: CapabilityIdEnum.Route,
  value: 'route',
  label: `${keyPrefix}route`,
};
const specificationTagVIP = {
  id: CapabilityIdEnum.TagVIP,
  value: 'tag_vip',
  label: `${keyPrefix}tag-vip`,
};
const specificationAutomation = {
  id: CapabilityIdEnum.Automation,
  value: 'automation',
  label: `${keyPrefix}automation`,
};
const specificationMarketing = {
  id: CapabilityIdEnum.Marketing,
  value: 'marketing',
  label: `${keyPrefix}marketing`,
};
const specificationReadOnly = {
  id: CapabilityIdEnum.ReadOnly,
  value: 'read_only',
  label: `${keyPrefix}read-only`,
};
// const specificationEngagement = {
//   id: CapabilityIdEnum.Engagement,
//   value: 'one_to_one_engagement',
//   label: `${keyPrefix}engagement`,
// };

/**
 * Convenience method that provides the capabilities specification as array.
 * @returns the specifications in the order of display.
 */
export function getCapabilitySpecifications(): CapabilitySpecification[] {
  return [
    specificationReadOnly,
    specificationAnswer,
    specificationActions,
    specificationStatistics,
    specificationPublish,
    specificationProcessHelpRequests,
    specificationRoute,
    specificationTagVIP,
    specificationAutomation,
    specificationMarketing,
    // specificationEngagement, // Uncomment when ready to be used
  ];
}
